import banner from '../../images/login-banner.png';
import styles from './index.module.css';

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>{title}</h2>
      <p className={styles.sectionBody}>{children}</p>
    </div>
  );
}

function Terms() {
  return (
    <div className={styles.page}>
      <div className={styles.brandBar}>
        <img src={banner} alt="Joyya" className={styles.brandLogo} />
      </div>
      <div className={styles.content}>
        <div className={styles.doc}>
          <h1 className={styles.docTitle}>Terms of Service</h1>
          <p className={styles.docSubtitle}>Last updated: March 20, 2026</p>
          <hr className={styles.divider} />

          <p className={styles.sectionBody} style={{ marginBottom: '1.75em' }}>
            By using any Joyya products or services, you are agreeing to these Terms of Service.
            Violation of these terms may result in the termination of your account.
          </p>

          <Section title="1. Definitions">{`"Company", "we", or "us" refers to Joyya.\n"Services" refers to our websites, including joyya.com, and any product or application created and maintained by Joyya.\n"You" refers to the people or organizations that own an account with our Services.`}</Section>

          <Section title="2. Account Terms">{`• You are responsible for maintaining the security of your account and password.\n• You are responsible for all content posted and activity that occurs under your account.\n• You must be a human. Accounts registered by "bots" or automated methods are not permitted.`}</Section>

          <Section title="3. Termination">
            We reserve the right to suspend or terminate accounts for any reason at any time,
            particularly in cases of verbal or physical abuse of Joyya staff.
          </Section>

          <Section title="4. Content & Copyright">
            You may not duplicate, copy, or reuse any portion of the HTML, CSS, JavaScript, or
            visual design elements of the Joyya app without express written permission.
          </Section>

          <Section title="5. Liability">
            You agree that Joyya is not liable for any direct, indirect, or consequential damages
            resulting from your use of the Services or unauthorized access to your data.
          </Section>

          <div className={styles.contact}>
            <p className={styles.contactLabel}>Questions?</p>
            <p className={styles.contactDesc}>
              If you have questions about these Terms, please reach out to us.
            </p>
            <a href="mailto:developers@joyya.com" className={styles.contactLink}>
              developers@joyya.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Terms };
